---
id: activity-log
title: User event logs
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - activity-log
  - user-events
  - microservice
---

## Product Overview

### Who it serves

This microservice records product activity events sent by frontend clients so downstream systems can analyze usage.

### Primary workflow

Clients submit activity payloads as structured user event actions that are stored as raw activity logs.

### Business rules

The service keeps payloads as raw event data and does not apply product decisions beyond validating and accepting well-formed event inputs.

### Outcomes

Downstream systems can query stored activity data to power reporting, analysis, or follow-on processing.

### Out of scope

User-facing analytics, enrichment, and aggregation logic are handled by other services or pipelines.

### API documentation

[Internal API documentation](https://wiki.rezi.ai/apis/activity-log-api-docs).

## Technical Overview

### Architecture flow

The Gin router in `apps/micro-services/activity-log/pkg/routes/routes.go` exposes a `/v1/activity-logs` POST endpoint that passes requests through `ActivityLogController` and into `ActivityLogService` for persistence.

### Entry points

- Requests enter through `ActivityLogController.Create` in `apps/micro-services/activity-log/pkg/api/controllers/activitylog.go`, which unmarshals `rezi_proto.UserAdvancedReportAction` and converts it into `entities.InsertLogParam` before calling `ActivityLogService.InsertNewLog`.
- The OpenAPI spec generator entry point is `apps/micro-services/activity-log/cmd/spec/main.go`.

### Data sources and sinks

`ActivityLogService` writes events via `DBAPICaller.Save`, and in production it also emits Slack notifications for selected resume creation events.

### Integrations and side effects

The service calls the db-api for storage and uses a Slack messenger integration when `config.IsProd()` is true and event metadata matches supported resume creation methods.

### Constraints and risks

Because the handler accepts protobuf JSON with `AllowPartial` and `DiscardUnknown`, upstream clients must keep payloads aligned with `rezi_proto.UserAdvancedReportAction` to avoid silent data loss.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Added the OpenAPI spec generator entry point.
- 2026-01-30: Initial documentation.
